<template>
    <div class="user-details" :class="classObject">
        <slot />
        <div class="user-name">
            <p>{{ user.name }}</p>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        layout: {
            type: String,
            default: 'small',
        },
    },

    computed: {
        ...mapState(['user']),

        /**
         * Return style class.
         *
         * @returns {string} Class name.
         */
        classObject() {
            return {
                [`layout-${this.layout}`]: true,
            };
        },
    },
};
</script>
